import { all, call, takeEvery, fork, take } from "redux-saga/effects";
import requestFunction from "../Utils/SagaGenericFunction";
import newSGF from "../Utils/newSGF";


import { 
  CREATE_BUSINESS_MANAGEMENT, 
  EXPORT_BUSINESS_MANAGEMENT, 
  FETCH_ALL_BUSINESS_MANAGEMENT, 
  FETCH_BUSINESS_MANAGEMENT_BY_ID, 
  FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION, 
  FETCH_TOTAL_BUSINESS_MANAGEMENT, 
  UPDATE_BUSINESS_MANAGEMENT 
} from "../ActionTypes";

import { 
  addBusinessManagementFailure, 
  addBusinessManagementSuccess, 
  exportBusinessManagementSuccess, 
  fetchBusinessManagementByIdSuccess, 
  fetchBusinessManagementSuccess, 
  fetchBusinessManagementWithoutPaginationSuccess, 
  fetchTotalBusinessManagementSuccess, 
  updateBusinessManagementSuccess,
  updateBusinessManagementFailure,
} from "../Actions";

import { 
  createBusinessManagement, 
  exportBusiness, 
  getBusinessManagement, 
  getBusinessManagementByIdApi, 
  getBusinessManagementWithoutPagination, 
  getTotalBusinesManagement, 
  updateBusinessMgt
} from "../Api";

// =================Create New Business sagas================

const createBusinessManagementRequest = function* ({ payload }) {
  yield call(newSGF, addBusinessManagementSuccess, addBusinessManagementFailure, createBusinessManagement, payload);
};

export const createBusinessManagementWatcher = function* () {
  yield takeEvery(CREATE_BUSINESS_MANAGEMENT, createBusinessManagementRequest);
};


// =================Fetch Business sagas================

const fetchBusinessManagementRequest = function* ({ payload }) {
    yield call(requestFunction, fetchBusinessManagementSuccess, getBusinessManagement, payload);
  };
  
  export const fetchBusinessManagementWatcher = function* () {
    yield takeEvery(FETCH_ALL_BUSINESS_MANAGEMENT, fetchBusinessManagementRequest);
  };
  

  // =================Update Skill set sagas================
const updateBusinessManagementRequest = function* ({ payload }) {
  yield call(newSGF, updateBusinessManagementSuccess, updateBusinessManagementFailure, updateBusinessMgt, payload);
};

export const updateTheSkillSet = function* () {
  yield takeEvery(UPDATE_BUSINESS_MANAGEMENT, updateBusinessManagementRequest);
};


  // =================EXPORT Business sagas================
const exportBusinessFileRequest = function* ({ payload }) {
    yield call(requestFunction, exportBusinessManagementSuccess, exportBusiness, payload);
  };
  
  export const exportBusinessFile = function* () {
    yield takeEvery(EXPORT_BUSINESS_MANAGEMENT, exportBusinessFileRequest);
  };
  

// =================Fetch Business No Pagination sagas================

const fetchBusinessManagementNoPaginationRequest = function* ({ payload }) {
  yield call(requestFunction, fetchBusinessManagementWithoutPaginationSuccess, getBusinessManagementWithoutPagination, payload);
};

export const fetchBusinessManagementNoPaginationWatcher = function* () {
  yield takeEvery(FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION, fetchBusinessManagementNoPaginationRequest);
};

// =================Fetch Total Business sagas================

const fetchTotalBusinessManagementRequest = function* ({ payload }) {
  yield call(requestFunction, fetchTotalBusinessManagementSuccess, getTotalBusinesManagement, payload);
};

export const fetchTotalBusinessManagementWatcher = function* () {
  yield takeEvery(FETCH_TOTAL_BUSINESS_MANAGEMENT, fetchTotalBusinessManagementRequest);
};



// =================Fetch Business by id sagas================

const fetchBusinessManagementByIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchBusinessManagementByIdSuccess, getBusinessManagementByIdApi, payload);
};

export const fetchBusinessManagementByIdWatcher = function* () {
  yield takeEvery(FETCH_BUSINESS_MANAGEMENT_BY_ID, fetchBusinessManagementByIdRequest);
};





export default function* rootSaga() {
  yield all([fork(createBusinessManagementWatcher),fork(fetchBusinessManagementWatcher), fork(updateTheSkillSet), fork(exportBusinessFile), fork(fetchBusinessManagementNoPaginationWatcher), fork(fetchTotalBusinessManagementWatcher), fork(fetchBusinessManagementByIdWatcher)]);
}
